import { connect } from 'react-redux';
import HubSettingsView from './view';
import { fetchUserManagementList } from 'src/legacy/redux/actions/userManagement';
import { fetchAllHubLayouts, 
  enableLayoutAccessForUserGroups, 
  deleteHubLayout, updateHubLayout} from 'src/redux/actions/hub.ts';
import hasAccess from 'src/legacy/services/hasAccess';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    layouts: _.get(state, 'hub.layouts', null),
    userGroups : _.get(state, "legacyRootReducer.settings.userManagement.items",[]),
    deleting: _.get(state, 'hub.layouts.deleting', false),
    enablingAccess: _.get(state, 'hub.layouts.enablingAccess', false),
    loading: _.get(state, 'hub.loading', false),
    updated: _.get(state, 'hub.update.succeeded', false)
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserManagementList: (page, query, filterType) => {
      dispatch(fetchUserManagementList(page, query, filterType))
    },

    updateHubLayout: (layout) => {
      return dispatch(updateHubLayout(layout));
    },

    fetchAllHubLayouts: (fetchUserGroups) => {
      return dispatch(fetchAllHubLayouts(fetchUserGroups));
    },


    enableLayoutAccessForUserGroups: (layoutId, userGroups) => {
      return dispatch(enableLayoutAccessForUserGroups(layoutId, userGroups));
    },

    deleteHubLayout: (layoutId) => {
      return dispatch(deleteHubLayout(layoutId));
    }
  }
}

const HubSettingsPage = connect (
  mapStateToProps,
  mapDispatchToProps
)(HubSettingsView);

export default hasAccess(HubSettingsPage, 'hub-settings');